import { DATE_TIME_LOCAL_FORMAT } from "@dgs/core";
import { isEqual, parse, parseISO } from "date-fns";
import { DataFieldType } from "../../../shared/types";
import { DataFieldRuleValidator } from "./types";

export const dataFieldHasValue: DataFieldRuleValidator = {
	validate: ({ isImplicitlyRequired }, dataFieldType, dataFieldValue, ruleValue) => {
		if (dataFieldValue === undefined || dataFieldValue === null) {
			return !isImplicitlyRequired;
		}
		switch (dataFieldType) {
			case DataFieldType.CHECKBOX_GROUP: {
				return (
					(ruleValue as number[]).length === (dataFieldValue as number[]).length &&
					(ruleValue as number[]).every((x) => (dataFieldValue as number[]).includes(x))
				);
			}
			case DataFieldType.MULTI_SELECT_FIELD: {
				return (
					(ruleValue as number[]).length === (dataFieldValue as number[]).length &&
					(ruleValue as number[]).every((x) => (dataFieldValue as number[]).includes(x))
				);
			}
			case DataFieldType.URL:
			case DataFieldType.EMAIL:
			case DataFieldType.LONG_TEXT:
			case DataFieldType.TEXT:
			case DataFieldType.CRYPT:
				return ruleValue === dataFieldValue;
			case DataFieldType.CHECKBOX:
			case DataFieldType.SELECT_FIELD:
			case DataFieldType.TIME:
			case DataFieldType.PHONE:
				return ruleValue === dataFieldValue;
			case DataFieldType.RADIO:
				return ruleValue === parseInt(dataFieldValue as string, 10);
			case DataFieldType.NUMBER:
				return +(ruleValue as number) === +dataFieldValue;
			case DataFieldType.DATE:
				return isEqual(
					parse(ruleValue as string, "yyyy-MM-dd", new Date()),
					parse(dataFieldValue as string, "yyyy-MM-dd", new Date()),
				);
			case DataFieldType.DATETIME:
				return isEqual(ruleValue as string, parseISO(dataFieldValue as string));
			case DataFieldType.LOCAL_DATETIME:
				return isEqual(ruleValue as string, parse(dataFieldValue as string, DATE_TIME_LOCAL_FORMAT, new Date()));
		}
		return false;
	},

	getErrorMessage: ({ t, formatDateTime, formatDate }, dataField, _, ruleValue) => {
		const key = "Field must have value {{value}}";
		const values = { value: "" };

		switch (dataField.type) {
			case DataFieldType.RADIO:
				values.value = dataField.options.find((x) => x.id === ruleValue)?.value ?? "";
				break;
			case DataFieldType.SELECT_FIELD:
				values.value = dataField.options.find((x) => x.id === ruleValue)?.value ?? "";
				break;
			case DataFieldType.CHECKBOX_GROUP:
			case DataFieldType.MULTI_SELECT_FIELD: {
				const value = ruleValue as number[];
				values.value = dataField.options
					.filter((x) => value.includes(x.id))
					.map((x) => x.value)
					.join(", ");
				break;
			}
			case DataFieldType.CHECKBOX:
				values.value = ruleValue ? "true" : "false";
				break;
			case DataFieldType.DATE:
				values.value = formatDate(ruleValue as string);
				break;
			case DataFieldType.DATETIME:
			case DataFieldType.LOCAL_DATETIME:
				values.value = formatDateTime(ruleValue as string);
				break;
			default:
				values.value = ruleValue as string;
		}

		return t(key, values);
	},
};
